import { render, staticRenderFns } from "./ImageEmptyIcon.vue?vue&type=template&id=ddc64e1e"
import script from "./ImageEmptyIcon.vue?vue&type=script&lang=js"
export * from "./ImageEmptyIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports